export const MAX_IMAGE_WIDTH = 460;
